export enum USERROLE {
    NULL = 'NULL',
    FA = 'FA',
    BM = 'BM',
    HO = 'HO',
    COMP = 'COMP',
    OPS = 'OPS',
    SUPER = 'SUPER',
    SUPERVISION = 'SUPERVISION',
  }

  export class TodoItemNode {
    children!: TodoItemNode[];
    label!: string;
    id!: string;
    isChecked!: boolean;
  }

  export class AdvisorHirerarchy {
    regions!: AdvisorRegion[];
  }
  export class AdvisorRegion {
    regName!: string;
    hubs!: AdvisorHub[];
    isInc: boolean;
    constructor() {
      this.isInc = true;
    }
  }
  export class AdvisorHub {
    hubName!: string;
    teams!: AdvisorTeam[];
    isInc: boolean;
    constructor() {
      this.isInc = true;
    }
  }
  export class AdvisorTeam {
    teamName!: string;
    advisors!: AdvNameId[];
    isInc: boolean;
    constructor() {
      this.isInc = true;
    }
  }
  
  export class AdvNameId {
    repId!: string;
    repName!: string;
    isInc: boolean;
    constructor() {
      this.isInc = true;
    }
  }

  export interface EmailPayload {
  to: string;
  subject: string;
  body: string;
}

export interface EmailRequest {
  EmailIds: string[];
  Source: string;
  Status: string;
  DueDate: string;
  Rag: string;
  isComplianceApp: string ;
  Organization: string;
}

export interface BulkEmailPrepareRequest {
  EmailIds: string[];
}

  export enum Status {
  Completed  = 'Completed Approved',
  Pending = 'Pending Completion',
    InReview = 'In Review',
  
 
}


  export enum Source {
  RegEd  = 'RegEd',
  Starcomp = 'Star Compliance',
  FINRA = 'FINRA',


}